import { decodeHtmlTokens } from '@metapic-apps/shared'
import { type Notification } from '@novu/js'

import { normalizeImage } from '@/lib/adapters/image.adapter'
import { type NotificationServerType, type NotificationType } from '@/lib/types/notifications.types'

export const normalizeNotification = (item: NotificationServerType): NotificationType => {
  return {
    id: item.id,
    read: item.read,
    data: {
      events: item.data.events.map((event) => ({
        id: event.id,
        time: event.time,
        payload: {
          _identifier: event.payload._identifier,
          actor: {
            id: event.payload.actor.id,
            name: decodeHtmlTokens(event.payload.actor.name),
            subscriberId: event.payload.actor.subscriberId,
          },
          action: event.payload.action,
          campaign: {
            id: Number(event.payload.campaign.id),
            name: decodeHtmlTokens(event.payload.campaign.name),
          },
          participant: {
            id: event.payload.participant.id,
            name: decodeHtmlTokens(event.payload.participant.name),
            avatar:
              event.payload.participant.avatar && normalizeImage(event.payload.participant.avatar),
          },
          advertiser: {
            id: event.payload.advertiser.id,
            name: decodeHtmlTokens(event.payload.advertiser.name),
            logo: event.payload.advertiser.logo && normalizeImage(event.payload.advertiser.logo),
          },
        },
      })),
    },
    createdAt: item.created_at,
  }
}

export const normalizeNotifications = (data: NotificationServerType[]): NotificationType[] => {
  return data.filter((item) => item.data?.events).map(normalizeNotification)
}

const hasNotificationEvents = (
  data: Notification['data'],
): data is NotificationServerType['data'] => Array.isArray(data?.events)

export const normalizeInboxNotifications = (
  notifications: Notification[],
  subscriberId: string,
): NotificationType[] =>
  notifications.flatMap((item) => {
    if (!hasNotificationEvents(item.data)) {
      return []
    }

    return [
      normalizeNotification({
        id: item.id,
        subscriber_id: subscriberId,
        read: item.isRead,
        created_at: item.createdAt,
        data: item.data,
      }),
    ]
  })
